import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import HomePage from './pages/Home';
import CompanyListPage from './pages/CompanyList';
import AboutUsPage from './pages/AboutUs';
import ForCompaniesPage from './pages/ForCompanies';
import JobfairPlanPage from './pages/JobfairPlan';
import ContestPage from './pages/Contest';
import TimelinePage from './pages/TimelinePage';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsTracker from './components/AnalyticsTracker';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
  <Router>
    <ScrollToTop/>
    <AnalyticsTracker />
  <Routes>
        <Route index element={<HomePage/>} />
        <Route path='/company-list' element={<CompanyListPage/>} />
        <Route path='/about' element={<AboutUsPage/>} />
        <Route path='/for-companies' element={<ForCompaniesPage/>} />
        <Route path='/plan' element={<JobfairPlanPage/>} />
        <Route path='/contest' element={<ContestPage/>} />
        <Route path='/timelinePage' element={<TimelinePage/>} />

  </Routes>
  </Router>
  </React.StrictMode>
);
